module.exports = __webpack_public_path__ + "img/science.d0d943de.png";